import type { Preferences } from 'api/types/preferences.types';
import type { CSSProperties } from 'react';
import * as React from 'react';
import { useMemo } from 'react';
import { Col, Form } from 'react-bootstrap';
import { styled } from 'styled-components';

import PreferenceItems from './PreferenceItems';

const StyledOptionContainer = styled.div<{
  maxHeight?: number;
}>`
  overflow: scroll;
  max-height: ${window.innerHeight / 1.7}px;

  @media (max-height: 600px) {
    max-height: ${window.innerHeight / 2.5}px;
  }
`;

interface OrderInstructionFormProps {
  onChangeValue: (optionType: string) => void;
  preference?: Preferences.Preference;
  selectedOptions: string[];
  optionType?: string;
  preferenceDescription?: string;
  hideCategoryName?: boolean;
  checkboxType?: 'checkbox' | 'badge';
  formRef?: React.RefObject<HTMLFormElement>;
  extraKey?: string;
  categoryNameStyle?: CSSProperties;
  alwaysHighlightOptionTitle?: boolean;
}

const OrderInstructionForm = ({
  onChangeValue,
  preference,
  categoryNameStyle,
  selectedOptions,
  formRef,
  checkboxType,
  optionType,
  preferenceDescription,
  hideCategoryName,
  extraKey = '',
  alwaysHighlightOptionTitle,
}: OrderInstructionFormProps) => {
  const options = useMemo(
    () =>
      preference && (
        <Form ref={formRef}>
          {preference.categories.map((category, iOpt) => (
            <PreferenceItems
              optionType={optionType}
              category={category}
              index={iOpt}
              preference={preference}
              selectedOptions={selectedOptions}
              onChangeValue={onChangeValue}
              hideCategoryName={hideCategoryName}
              preferenceDescription={preferenceDescription}
              checkboxType={checkboxType}
              extraKey={extraKey}
              categoryNameStyle={categoryNameStyle}
              alwaysHighlightOptionTitle={alwaysHighlightOptionTitle}
            />
          ))}
        </Form>
      ),
    [
      preference,
      formRef,
      optionType,
      selectedOptions,
      onChangeValue,
      hideCategoryName,
      preferenceDescription,
      checkboxType,
      extraKey,
      categoryNameStyle,
      alwaysHighlightOptionTitle,
    ]
  );

  return (
    <StyledOptionContainer className="overflow-auto">
      <Col xs={12}>{options}</Col>
    </StyledOptionContainer>
  );
};

export default OrderInstructionForm;
